import React, { Component } from 'react';

const IMG = '/build/web/igame-index-lobby-wm/img';

const groups = [
  {
    title: 'ผู้สนับสนุนหลัก',
    items: [
      { img: 'https://s3.newworld.center/image/ded4f2d7-9b0a-4689-8b48-af4d9c906a4d.webp', name: 'PK8 CASINO' },
    ],
  },
  {
    title: 'ผู้สนับสนุนหลักทางการ',
    items: [ { pending: true } ],
  },
  {
    title: 'สปอนเซอร์หลักทางการ',
    items: [ { pending: true } ],
  },
  {
    title: 'ผู้สนับสนุนก่อนหน้าของเรา',
    items: [ { pending: true } ],
  },
];

const news = [
  { title: 'PK8 News ขึ้นแท่นผู้สนับสนุนอย่างเป็นทางการของ BWF 2026', desc: 'PK8 News ได้รับการแต่งตั้งเป็นผู้สนับสนุนอย่างเป็นทางการของการแข่งขัน BWF Thomas & Uber Cup Finals 2026', date: '29/04/2026' },
  { title: 'PK8 x Gresini MotoGP', desc: 'PK8 ประกาศความร่วมมือครั้งสำคัญในฐานะผู้สนับสนุนหลักอย่างเป็นทางการของทีม Gresini Racing MotoGP', date: '24/02/2025' },
  { title: 'PK8 x BWF', desc: 'PK8 ทำหน้าที่เป็นผู้สนับสนุนอย่างเป็นทางการของ HSBC BWF ในปี 2024', date: '10/05/2024' },
];

class SponsorsPage extends Component {
  // ──────────── card ใช้ร่วม ────────────
  card(item, mobile, key) {
    // placeholder "อยู่ระหว่างดำเนินการ" (ขนาดเท่าการ์ดเดิม)
    if (item.pending) {
      return (
        <div key={key} style={{
          background: '#0e2040', border: '1px dashed #2c4a78', borderRadius: 14,
          padding: mobile ? '16px 10px' : '22px 16px', textAlign: 'center',
        }}>
          <div style={{
            height: mobile ? 74 : 96, display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 12,
          }}>
            <svg width={mobile ? 32 : 40} height={mobile ? 32 : 40} viewBox="0 0 24 24" fill="none" stroke="#f5a623" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
          </div>
          <div style={{ fontSize: mobile ? 13 : 14.5, fontWeight: 700, color: '#9fb3cc' }}>อยู่ระหว่างดำเนินการ</div>
        </div>
      );
    }

    return (
      <div key={key} style={{
        background: '#0e2040', border: '1px solid #1e3560', borderRadius: 14,
        padding: mobile ? '16px 10px' : '22px 16px', textAlign: 'center',
      }}>
        <div style={{ height: mobile ? 74 : 96, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
          <img src={item.img} alt={item.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.4))' }} />
        </div>
        <div style={{ fontSize: mobile ? 13 : 15, fontWeight: 700, color: '#fff' }}>{item.name}</div>
        {item.sub && <div style={{ fontSize: mobile ? 11.5 : 12.5, color: '#f5a623', marginTop: 4 }}>{item.sub}</div>}
      </div>
    );
  }

  renderHero(mobile) {
    return (
      <div style={{ position: 'relative', overflow: 'hidden', background: 'linear-gradient(135deg,#051030,#0d2348 60%,#1a3a6e)', padding: mobile ? '34px 20px' : '64px 48px' }}>
        <div style={{ fontSize: mobile ? 12 : 14, color: '#f5a623', letterSpacing: 2, marginBottom: 6 }}>Official Sponsorships</div>
        <h1 style={{ fontSize: mobile ? 26 : 38, fontWeight: 800, margin: 0, color: '#fff' }}>ผู้สนับสนุนของ PK8</h1>
        <p style={{ marginTop: 10, fontSize: mobile ? 13 : 15, color: '#c8d6e5', maxWidth: 520 }}>
          PK8 ภูมิใจในการเป็นผู้สนับสนุนอย่างเป็นทางการให้กับทีมกีฬาและการแข่งขันระดับโลก ตอกย้ำความเป็นแบรนด์ชั้นนำของเอเชีย
        </p>
      </div>
    );
  }

  renderGroups(mobile) {
    return groups.map((g) => (
      <div key={g.title} style={{ maxWidth: 1000, margin: '0 auto', padding: mobile ? '20px 14px 0' : '34px 32px 0' }}>
        <h2 style={{ fontSize: mobile ? 16 : 20, fontWeight: 700, color: '#f5a623', marginBottom: mobile ? 12 : 18, textAlign: mobile ? 'center' : 'left' }}>{g.title}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: mobile ? 'repeat(2,1fr)' : 'repeat(auto-fill, minmax(180px,1fr))', gap: mobile ? 12 : 18 }}>
          {g.items.map((it, idx) => this.card(it, mobile, `${g.title}-${idx}`))}
        </div>
      </div>
    ));
  }

  renderNews(mobile) {
    return (
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: mobile ? '26px 14px 40px' : '44px 32px 56px' }}>
        <h2 style={{ fontSize: mobile ? 16 : 20, fontWeight: 700, color: '#fff', marginBottom: mobile ? 12 : 18, textAlign: mobile ? 'center' : 'left' }}>ข่าวสารการสนับสนุน</h2>
        <div style={{ display: 'grid', gridTemplateColumns: mobile ? '1fr' : 'repeat(auto-fill, minmax(280px,1fr))', gap: mobile ? 12 : 18 }}>
          {news.map((n, i) => (
            <div key={i} style={{ background: '#0e2040', border: '1px solid #1e3560', borderRadius: 12, padding: mobile ? '16px' : '20px' }}>
              <div style={{ fontSize: 11.5, color: '#f5a623', marginBottom: 8 }}>{n.date}</div>
              <div style={{ fontSize: mobile ? 14 : 15, fontWeight: 700, color: '#fff', marginBottom: 8, lineHeight: 1.45 }}>{n.title}</div>
              <div style={{ fontSize: mobile ? 12.5 : 13, color: '#9fb3cc', lineHeight: 1.7 }}>{n.desc}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    const mobile = window.innerWidth <= 760;
    return (
      <div style={{ background: '#0a1628', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif' }}>
        {this.renderHero(mobile)}
        {this.renderGroups(mobile)}
        {this.renderNews(mobile)}
      </div>
    );
  }
}

export default SponsorsPage;
